const normalizeEmail = (email: string) => {
    return email.replace(/\s+/g, '').toLowerCase();
}
  
const userIsAlreadyInvited = (allUniqueEmails: string[] | null, invitationEmail: string) => {
    if (allUniqueEmails === null) return false;
  
    const normalizedInvitationEmail = normalizeEmail(invitationEmail);
  
    return allUniqueEmails.some(
      (email) => normalizeEmail(email) === normalizedInvitationEmail
    );
}
  
export default userIsAlreadyInvited;
  